import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { Component, inject, OnInit } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { authConfigMasp } from "src/app/shared/auth/models/auth-masp.config";
import { HeaderGovBrComponent } from "../main/header-gov-br/header-gov-br.component";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';

@Component({
    templateUrl: './loginMasp.component.html',
    styleUrls: ['./loginMasp.component.scss'],
    standalone: true,
    imports:[HeaderGovBrComponent]
})

export class LoginMaspComponent implements OnInit {
  oauthService = inject(OAuthService);
  spinnerService = inject(NgxSpinnerService);
  authService = inject(AuthService);
  ConvivaErrors = inject(ConvivaErrorHandlingService);

  constructor(private http: HttpClient, private router: Router) {
    this.configure();
  }

  private configure() {
    this.oauthService.configure(authConfigMasp);
  }

  ngOnInit(): void {
    this.inicializar();
  }

  private async inicializar(): Promise<void> {
    this.oauthService.initCodeFlow();
  }
}
